<div class="row">
  <div class="col-lg-12">
    <div class="card">
      <div class="card-body">
        <div class="vl-toolbar">
          <input class="vl-input" type="search" placeholder="Cari nama, email, atau username&hellip;"
                 aria-label="Cari admin" [value]="isKeyword"
                 (input)="onKeywordInput($event.target.value)" (keyup.enter)="applyFilter()">
          <div class="vl-spacer"></div>
          <button type="button" class="vl-btn-primary" *ngIf="isSuperAdmin" (click)="onShowAdd()"
                  data-bs-toggle="modal" data-bs-target="#formData">+ Tambah Admin</button>
        </div>
        <div class="row">
          <div class="col-lg-12">
            <div class="vl-card">
              <div class="vl-loading" *ngIf="isTableLoading">
                <img src="assets/images/preloaders/3.svg" class="vl-loading-img" alt="Memuat data">
              </div>
              <div class="vl-scroll">
              <table class="vl-table">
                <thead>
                <tr>
                  <th class="vl-num">No</th>
                  <th>Nama</th>
                  <th>Email</th>
                  <th>Username</th>
                  <th>Role</th>
                  <th class="text-right" *ngIf="isSuperAdmin">Aksi</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let v of isData; let i = index" class="vl-row" [class.vl-alt]="i % 2 == 1">
                  <th class="vl-num">{{rowNo(i)}}</th>
                  <td>
                    <span class="vl-name" [innerHTML]="highlight(v.name)"></span>
                    <span *ngIf="v.id == isSelfId" class="vl-tag self">Anda</span>
                  </td>
                  <td class="vl-muted" [innerHTML]="highlight(v.email)"></td>
                  <td class="vl-muted" [innerHTML]="highlight(v.username)"></td>
                  <td><span class="vl-tag" [class.author]="v.roleInfo && v.roleInfo.name !== 'Admin'">{{roleLabel(v)}}</span></td>
                  <td *ngIf="isSuperAdmin">
                    <div class="vl-actions">
                      <button type="button" class="vl-icon" title="Login sebagai akun ini" *ngIf="v.id != isSelfId"
                              [disabled]="isImpersonating" (click)="onImpersonate(v)"><i class="fa fa-user-secret"></i></button>
                      <button type="button" class="vl-icon" title="Edit" (click)="onEdit(v)" data-bs-toggle="modal"
                              data-bs-target="#formData"><i class="fa fa-edit"></i></button>
                      <button type="button" class="vl-icon danger" title="Hapus" *ngIf="v.id != isSelfId"
                              (click)="onDelete(v)"><i class="fa fa-trash"></i></button>
                    </div>
                  </td>
                </tr>
                <tr *ngIf="!isData.length">
                  <td [attr.colspan]="isSuperAdmin ? 6 : 5" class="vl-empty">Tidak ada data</td>
                </tr>
                </tbody>
              </table><!--end /table-->
              </div>
              <div class="vl-foot">
                <span class="vl-summary">Menampilkan <b>{{formatNumber(summaryFrom())}}&ndash;{{formatNumber(summaryTo())}}</b> dari <b>{{formatNumber(isTotalAll)}}</b> admin</span>
                <div class="vl-spacer"></div>
                <nav class="vl-pager" aria-label="Navigasi halaman">
                  <button type="button" class="vl-page" [disabled]="isPage == 1" (click)="goToPage(isPage - 1)">&lsaquo;</button>
                  <ng-container *ngFor="let p of isPages">
                    <span *ngIf="p == '...'" class="vl-ellipsis">&hellip;</span>
                    <button *ngIf="p != '...'" type="button" class="vl-page" [class.active]="p == isPage"
                            (click)="goToPage(p)">{{p}}</button>
                  </ng-container>
                  <button type="button" class="vl-page" [disabled]="isPage == totalPages()" (click)="goToPage(isPage + 1)">&rsaquo;</button>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- FORM -->
<form [formGroup]="isForm" (ngSubmit)="onSubmit()">
  <div class="modal fade" id="formData" aria-labelledby="formDataLabel" aria-hidden="true" data-keyboard="false"
       data-backdrop="static">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header vf-header">
          <div>
            <h6 class="modal-title vf-title" id="formDataLabel">{{isForm.value.id ? 'Edit admin' : 'Tambah admin'}}</h6>
            <div class="vf-subtitle">{{isForm.value.id ? 'Perbarui detail akun admin ini.' : 'Buat akun admin baru untuk dashboard.'}}</div>
          </div>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" [disabled]="isLoading"></button>
        </div>
        <div class="modal-body">
          <div class="vf-grid">
            <div class="vf-field full">
              <label class="vf-label">Nama <span class="req">*</span></label>
              <input type="text" class="vf-input" [class.invalid]="isInvalid('name')"
                     placeholder="Nama lengkap" formControlName="name">
              <div class="vf-error" *ngIf="isInvalid('name')">Nama wajib diisi.</div>
            </div>
            <div class="vf-field">
              <label class="vf-label">Email <span class="req">*</span></label>
              <input type="email" class="vf-input" [class.invalid]="isInvalid('email')"
                     placeholder="nama@email.com" formControlName="email">
              <div class="vf-error" *ngIf="isInvalid('email')">Masukkan alamat email yang valid.</div>
            </div>
            <div class="vf-field">
              <label class="vf-label">Username <span class="req">*</span></label>
              <input type="text" class="vf-input" [class.invalid]="isInvalid('username')"
                     placeholder="Username untuk login" formControlName="username">
              <div class="vf-error" *ngIf="isInvalid('username')">Username wajib diisi.</div>
            </div>
            <div class="vf-field full">
              <label class="vf-label">Role <span class="req">*</span></label>
              <select class="vf-input vf-select" [class.invalid]="isInvalid('role_id')" formControlName="role_id">
                <option [ngValue]="''" disabled hidden>Pilih role</option>
                <option *ngFor="let d of dataRole" [ngValue]="d.id">{{d.name}}</option>
              </select>
              <div class="vf-error" *ngIf="isInvalid('role_id')">Role wajib dipilih.</div>
              <div class="vf-hint">Akses menu akun ini mengikuti role yang dipilih — atur di menu <b>Role</b>.</div>
            </div>
            <div class="vf-field full">
              <label class="vf-label">Password <span class="req" *ngIf="!isForm.value.id">*</span></label>
              <input type="password" class="vf-input" [class.invalid]="isInvalid('password')"
                     [placeholder]="isForm.value.id ? 'Biarkan kosong jika tidak diganti' : 'Minimal 6 karakter'"
                     formControlName="password" autocomplete="new-password">
              <div class="vf-hint" *ngIf="isForm.value.id">Isi hanya jika ingin mengganti password.</div>
              <div class="vf-error" *ngIf="isInvalid('password')">Password minimal 6 karakter.</div>
            </div>
          </div>
        </div>
        <div class="modal-footer vf-footer">
          <button type="button" class="vl-btn-ghost" data-bs-dismiss="modal" [disabled]="isLoading">Batal</button>
          <button type="submit" class="vl-btn-primary" [disabled]="isLoading">
            <i class="fa fa-spinner fa-spin" *ngIf="isLoading"></i> Simpan</button>
        </div>
      </div>
    </div>
  </div>
</form>

<!-- delete confirmation dialog (custom, design-system styled) -->
<div class="hds-overlay" *ngIf="isConfirm" (click)="closeConfirm()">
  <div class="hds-dialog" role="alertdialog" aria-modal="true" (click)="$event.stopPropagation()">
    <div class="hds-a">
      <span class="hds-ico">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
             stroke-linejoin="round"><path d="M3 6h18M8 6V4h8v2m-9 0l1 14h8l1-14"/></svg>
      </span>
      <h3>Hapus admin ini?</h3>
      <p>Akun ini tidak akan bisa masuk ke dashboard lagi.</p>
      <div class="hds-item">
        <span class="hds-item-text"><b>{{isConfirm.v.name}}</b><br>{{isConfirm.v.email}}</span>
      </div>
    </div>
    <div class="hds-foot hds-foot-full">
      <button type="button" class="vl-btn-ghost" [disabled]="isDeleting" (click)="closeConfirm()">Batal</button>
      <button type="button" class="hds-btn-danger" [disabled]="isDeleting" (click)="confirmDelete()">
        <i class="fa fa-spinner fa-spin" *ngIf="isDeleting"></i> Hapus</button>
    </div>
  </div>
</div>
